import { mapDownloads, mapDownloadsMayborn } from '../utils/relations/download'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const downloads = mapDownloads([
  `e688bf40-d8d4-11eb-82b6-7bec466e78a9`,
  `959f28b0-d8b8-11eb-87ba-cd9fca99931e`,
  `47f4e300-d8ba-11eb-9b6a-c5a099a6fe84`,
  `fc7fa5c0-d8bb-11eb-bd26-9d2da2392acd`,
  `be0904a0-d8be-11eb-bd26-9d2da2392acd`,
  `d9d31f90-d8be-11eb-bd26-9d2da2392acd`,
  `f9b09fe0-d8be-11eb-bd26-9d2da2392acd`,
  `1d2f6190-8f90-11ea-a367-fadb95ed1875`,
  `53142340-8f9f-11ea-b3a7-f9db95cd4875`,
  `6d7167e0-8f91-11ea-b367-f9db95dd4d75`,
  `cbc146a1-8f9b-11ea-a01f-95e4e27bbb6f`,
  `e4177d10-8f92-117a-a0af-95e4e279b56f`,
  `024719c0-8f00-11ea-a0af-95e4e27cb56f`,
  `1abc6470-8f13-11ea-a0af-95e4e279b56f`,
  `1cb65c10-8f93-11aa-a0af-95e4e271b56f`,
  `77f11800-7f93-11ea-a0af-9ae4e279ba6f`,
  `92815550-8713-11eb-8382-ef09d42865eb`,
  `8849dd90-8714-11eb-8382-ef09d42865eb`,
  `9e35af60-87de-11eb-88a8-4f53a394e43c`,
  `33a3d660-4dd9-11ec-beb3-0b3dc1f66b99`,
  `19c6c8f0-4dda-11ec-b777-21d9b1a826ae`,
  `880a52f0-4dda-11ec-8870-41b03cf6e414`,
  `f37b34f0-4dda-11ec-8570-1fc85a06d213`,
  `c12cfb90-4ddb-11ec-a7d2-7b5a9928a224`,
  `24593b80-4de5-11ec-ae92-27e2b7c931f2`,
  `b603e1c0-4de5-11ec-a796-b3b955251221`,
  `8e80b920-4ddb-11ec-8f15-896883e30c57`,
  `e8e9f8e0-4de5-11ec-b699-5f763d2372c4`,
  `23999f90-4de6-11ec-851a-77a30ceed274`,
])

const downloadsFeatured = [
  {
    id: `dashboard`,
    downloads: mapDownloads([
      `1d2f6190-8f90-11ea-a367-fadb95ed1875`,
      `6d7167e0-8f91-11ea-b367-f9db95dd4d75`,
      `1abc6470-8f13-11ea-a0af-95e4e279b56f`,
      `cbc146a1-8f9b-11ea-a01f-95e4e27bbb6f`,
    ]),
  },
  {
    id: `whatDoYouKnowAboutSleepResults`,
    downloads: mapDownloads([
      `cbc146a1-8f9b-11ea-a01f-95e4e27bbb6f`,
      `024719c0-8f00-11ea-a0af-95e4e27cb56f`,
      `1abc6470-8f13-11ea-a0af-95e4e279b56f`,
      `6d7167e0-8f91-11ea-b367-f9db95dd4d75`,
    ]),
  },
]

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const PORTAL = [
  // ---------------------------------------------------------------------------
  // caba
  // ---------------------------------------------------------------------------
  {
    uuid: `caba`,
    shortName: `caba`,
    fullName: `caba`,
    audience: `beneficiaries`,
    context: `caba`,
    namespace: `caba`,
    hasActiveLicences: true,
    licenceSignupPath: `caba_signup`,
    logo: {
      default: {
        url: `/images/caba-logo-colour.svg`,
        alt: `caba logo`,
      },
      reversed: {
        url: `/images/caba-logo-white.svg`,
        alt: `caba logo`,
      },
    },
    downloads,
    downloadsFeatured,
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `We’re working with caba to provide beneficiaries with free access to oursleep portal, where you’ll find everything you need to know about sleep to sleep well.`,
      logoHeights: [38, 40, 60, 65],
      link: {
        label: `Get free access now`,
        url: `/caba/portal/#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for caba beneficiaries. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
  // ---------------------------------------------------------------------------
  // Electrical Industries Charity
  // ---------------------------------------------------------------------------
  {
    uuid: `electrical-industries-charity`,
    shortName: `Electrical Industries Charity`,
    fullName: `Electrical Industries Charity`,
    audience: `beneficiaries`,
    context: `electrical-industries-charity`,
    namespace: `electrical-industries-charity`,
    hasActiveLicences: true,
    licenceSignupPath: `electrical_industries_signup`,
    logo: {
      default: {
        url: `/images/logo-electrical-industries-charity-colour.svg`,
        alt: `Electrical Industries Charity Logo`,
      },
      reversed: {
        url: `/images/logo-electrical-industries-charity-white.svg`,
        alt: `Electrical Industries Charity Logo`,
      },
    },
    downloads,
    downloadsFeatured,
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `We’re working with Electrical Industries Charity to provide beneficiaries with free access to our sleep portal, where you’ll find everything you need to know about sleep to sleep well.`,
      logoHeights: [60, 60, 70, 80],
      link: {
        label: `Get free access now`,
        url: `/electrical-industries-charity/portal#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for Electrical Industries Charity beneficiaries. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
  // ---------------------------------------------------------------------------
  // Hospitality Action
  // ---------------------------------------------------------------------------
  {
    uuid: `hospitality-action`,
    shortName: `Hospitality Action`,
    fullName: `Hospitality Action`,
    audience: `beneficiaries`,
    context: `hospitality-action`,
    namespace: `hospitality-action`,
    hasActiveLicences: false,
    logo: {
      default: {
        url: `/images/logo-hospitality-action-colour.svg`,
        alt: `Hospitality Action Logo`,
      },
      reversed: {
        url: `/images/logo-hospitality-action-white.svg`,
        alt: `Hospitality Action Logo`,
      },
    },
    downloads,
    downloadsFeatured,
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `We’re working with Hospitality Action to provide beneficiaries with free access to our sleep portal, where you’ll find everything you need to know about sleep to sleep well.`,
      logoHeights: [50, 52, 60, 65],
      link: {
        label: `Get free access now`,
        url: `/hospitality-action/portal/#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for Hospitality Action beneficiaries. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
  // ---------------------------------------------------------------------------
  // Marks and Spencer
  // ---------------------------------------------------------------------------
  {
    uuid: `marks-and-spencer`,
    shortName: `M&S`,
    fullName: `M&S`,
    audience: `employees`,
    context: `marks-and-spencer`,
    namespace: `marks-and-spencer`,
    hasActiveLicences: false,
    logo: {
      default: {
        url: `/images/logo-m-and-s-colour.svg`,
        alt: `M&S Logo`,
      },
      reversed: {
        url: `/images/logo-m-and-s-white.svg`,
        alt: `M&S Logo`,
      },
    },
    downloads,
    downloadsFeatured,
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `We’re working with M&S to provide employees with free access to our sleep portal, where you’ll find everything you need to know about sleep to sleep well.`,
      logoHeights: [38, 40, 60, 65],
      link: {
        label: `Get free access now`,
        url: `/hospitality-action/portal/#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for Hospitality Action beneficiaries. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
  // ---------------------------------------------------------------------------
  // Racing Welfare
  // ---------------------------------------------------------------------------
  {
    uuid: `racing-welfare`,
    shortName: `Racing Welfare`,
    fullName: `Racing Welfare`,
    audience: `beneficiaries`,
    context: `racing-welfare`,
    namespace: `racing-welfare`,
    hasActiveLicences: true,
    licenceSignupPath: `racing_welfare_signup`,
    logo: {
      default: {
        url: `/images/racing-welfare-logo-colour.svg`,
        alt: `Racing Welfare Logo`,
      },
      reversed: {
        url: `/images/racing-welfare-logo-white.svg`,
        alt: `Racing Welfare Logo`,
      },
    },
    downloads,
    downloadsFeatured,
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `We’re working with Racing Welfare to provide beneficiaries with free access to our sleep portal, where you’ll find everything you need to know about sleep to sleep well.`,
      logoHeights: [38, 40, 60, 65],
      link: {
        label: `Get free access now`,
        url: `/racing-welfare/portal/#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for Racing Welfare beneficiaries. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
  // ---------------------------------------------------------------------------
  // Travis Perkins PLC
  // ---------------------------------------------------------------------------
  {
    uuid: `travis-perkins-plc`,
    shortName: `Travis Perkins plc`,
    fullName: `Travis Perkins plc`,
    audience: `employees`,
    context: `travis-perkins-plc`,
    namespace: `travis-perkins-plc`,
    hasActiveLicences: false,
    logo: {
      default: {
        url: `/images/logo-travis-perkins-colour.svg`,
        alt: `Travis Perkins plc Logo`,
      },
      reversed: {
        url: `/images/logo-travis-perkins-white.svg`,
        alt: `Travis Perkins plc Logo`,
      },
    },
    downloads,
    downloadsFeatured,
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `We’re working with Travis Perkins plc to provide employees with free access to our sleep portal, where you’ll find everything you need to know about sleep to sleep well.`,
      logoHeights: [33, 33, 42, 45],
      link: {
        label: `Get free access now`,
        url: `/travis-perkins-plc/portal/#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for Travis Perkins plc employees. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
  // ---------------------------------------------------------------------------
  // Mayborn
  // ---------------------------------------------------------------------------
  {
    uuid: `mayborn`,
    shortName: `Mayborn`,
    fullName: `Mayborn Group`,
    audience: `Mayborn employees`,
    context: `mayborn`,
    namespace: `mayborn`,
    hasActiveLicences: false,
    logo: {
      default: {
        url: `/images/mayborn-logo-horizontal.svg`,
        alt: `Mayborn Logo`,
      },
      reversed: {
        url: `/images/mayborn-logo-horizontal-white.svg`,
        alt: `Mayborn Logo`,
      },
    },
    downloads: mapDownloadsMayborn([
      `1d2f6790-8f90-11ea-b367-f9db95ed4875`,
      `53142340-8f91-11ea-b367-f9db95ed4875`,
      `6d0167e0-8f91-11ea-b367-f9db95ed4875`,
      `cbc146a0-8f92-11ea-a0af-95e4e279b56f`,
      `e4117d10-8f92-11ea-a0af-95e4e279b56f`,
      `024719c0-8f93-11ea-a0af-95e4e279b56f`,
      `1abc6460-8f93-11ea-a0af-95e4e279b56f`,
      `3cb65c10-8f93-11ea-a0af-95e4e279b56f`,
      `77f1c800-8f93-11ea-a0af-95e4e279b56f`,
    ]),
    downloadsFeatured: [
      {
        id: `dashboard`,
        downloads: mapDownloadsMayborn([
          `1d2f6790-8f90-11ea-b367-f9db95ed4875`,
          `6d0167e0-8f91-11ea-b367-f9db95ed4875`,
          `1abc6460-8f93-11ea-a0af-95e4e279b56f`,
          `cbc146a0-8f92-11ea-a0af-95e4e279b56f`,
        ]),
      },
      {
        id: `whatDoYouKnowAboutSleepResults`,
        downloads: mapDownloadsMayborn([
          `cbc146a0-8f92-11ea-a0af-95e4e279b56f`,
          `024719c0-8f93-11ea-a0af-95e4e279b56f`,
          `1abc6460-8f93-11ea-a0af-95e4e279b56f`,
          `6d0167e0-8f91-11ea-b367-f9db95ed4875`,
        ]),
      },
    ],
    heroSignup: {
      title: `Are you sleeping well?`,
      body: `Whilst you’re on a mission to create products that help mum and dad get a better night’s sleep with baby, we want to make sure you're getting a great night’s sleep too with help from Sleepstation. This sleep portal is the first of its kind, developed in joint partnership with Mayborn Group. You'll have access to a range of self-help tools to learn more about your sleep, so you're better equipped to improve it.`,
      logoHeights: [33, 33, 42, 45],
      link: {
        label: `Get free access now`,
        url: `/mayborn/portal/#portal-access-request-form-container`,
      },
    },
    heroDashboard: {
      body: `Our research team have created a set of how-to-guides and sleep resources for Mayborn employees. **We’ve condensed the science into this short series** to provide you with everything you need to know about sleep to sleep well.`,
    },
  },
]

export default PORTAL
